import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {ItemGroupQuery, ItemGroupsQuery, ItemQuery, ItemsQuery} from "web-shared";
import {GLOBAL} from "common-shared";

@Component({
  selector: 'app-item-group-display-name',
  template: `
      <ng-container *ngIf="itemGroup; else byId">
        <ng-container [ngTemplateOutlet]="output" [ngTemplateOutletContext]="{itemGroup: itemGroup}"></ng-container>
      </ng-container>
      <ng-template #byId>
        <ng-container *ngIf="itemGroupsQuery.selectEntity(itemGroupId) | async as itemGroup">
          <ng-container [ngTemplateOutlet]="output" [ngTemplateOutletContext]="{itemGroup: itemGroup}"></ng-container>
        </ng-container>
      </ng-template>
      <ng-template #output let-itemGroup="itemGroup">
        <span [ngOptionHighlight]="searchTerm" [title]="itemGroup | displayName">{{itemGroup | displayName: nameOnly: codeOnly}}</span><span *ngIf="itemGroup.StatusClv == ItemGroupStatus.Draft" class="badge bg-default ms-1" title="Draft">D</span>
      </ng-template>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ItemGroupDisplayNameComponent {
  @Input() itemGroup: ItemGroupQuery;
  @Input({transform: (value: unknown): string => value as string}) itemGroupId: string;
  @Input() nameOnly: boolean = false;
  @Input() codeOnly: boolean = false;
  @Input() searchTerm: string;
  ItemGroupStatus = GLOBAL.Classificators.ItemGroupStatus;

  constructor(public itemGroupsQuery: ItemGroupsQuery) {
  }
}
